<span class="risk-badge" [ngClass]="badgeClass || riskLevel">
    <span *ngIf="riskLevel !== null && riskLevel !== undefined && riskLevel !== ''" class="badge-content">
        <span *ngIf="hasDot" class="dot"></span>
        <ng-container *ngIf="riskLevel === 'codeCheckDone'; else formattedRisk">
            Code Check Done
        </ng-container>
        <ng-template #formattedRisk>
            <ng-container
                *ngIf="displayRiskLevel === 'Processing' || displayRiskLevel === 'Suspended' || displayRiskLevel === 'Access pending' ; else normalRisk">
                {{ displayRiskLevel }}
            </ng-container>
            <ng-template #normalRisk>
                {{ displayRiskLevel + ' ' + riskString }}
            </ng-template>
        </ng-template>
    </span>

    <span *ngIf="riskLevel && hasFlag && riskLevel !== 'codeCheckDone'" class="divider">|</span>
    <span *ngIf="riskLevel === null || riskLevel === undefined || riskLevel === ''" [ngClass]="badgeClass || riskLevel"
        class="badge-content">N/A</span>

    <img *ngIf="riskLevel && riskLevel === 'codeCheckDone'" src="assets/images/icons/check-circled-filled.png"
        alt="check" class="check-icon" />

    <img *ngIf="riskLevel && hasFlag && riskLevel !== 'codeCheckDone'" src="assets/images/icons/high_flag.png"
        alt="flag" class="flag-icon" />
</span>